(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("iroDynamicCss", [], factory);
	else if(typeof exports === 'object')
		exports["iroDynamicCss"] = factory();
	else
		root["iroDynamicCss"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return 